import { validateEmail } from "utils/regexValidatorHelper";
import commonMessage from "../../constant/commonMessage";


const {
SUPPORT_MESSAGE_REQUIRED,EMAIL_REQUIRED,INVALID_EMAIL
} = commonMessage;

export const support = {
  //create support Schema
  createSupportTicketSchema: {
    message: {
      required: true,
      message: SUPPORT_MESSAGE_REQUIRED,
    }
  },
  // Contact us schema
  createContactUsSchema: {
    email: {
      required: true,
      message: EMAIL_REQUIRED,
      validate: (value, inputData = {}) => {
        return validateEmail(value);
      },
      invalidMessage: INVALID_EMAIL,
      extraMessage: true,
    },
    message: {
      required: true,
      message: SUPPORT_MESSAGE_REQUIRED,
    }

  },
};
